import { useTranslate } from "@refinedev/core";
import type { MutableRefObject } from "react";
import { ProjectSettingForm } from "pages/media/projects/components/ProjectSettingForm/";
import { BrandKit } from "pages/media/types/";
import { Modal } from "@libertify/ui";

export type BrandkitChangeModalProps = {
  projectId?: string;
  storyboardId?: string;
  instanceId?: string;
  brandKitId?: string;
  open: boolean;
  selectedBrandKitRef: MutableRefObject<BrandKit | null>;
  onCancel: () => void;
  onClose: () => void;
};

export const BrandkitChangeModal = ({
  projectId,
  storyboardId,
  instanceId,
  brandKitId,
  open,
  selectedBrandKitRef,
  onCancel,
  onClose,
}: BrandkitChangeModalProps) => {
  const t = useTranslate();

  if (!projectId) {
    return null;
  }

  return (
    <Modal open={open} onClose={onCancel} footer={null} size="large">
      <ProjectSettingForm
        type={"BrandKit"}
        icon={<></>}
        title={t("projects.components.ProjectSettings.brandKit")}
        subtitle={t("projects.components.ProjectSettings.chooseYourBrand")}
        projectId={projectId}
        storyboardId={storyboardId}
        instanceId={instanceId}
        value={brandKitId}
        onBrandKitChanged={(bk) => {
          selectedBrandKitRef.current = bk;
        }}
        onClose={onClose}
        cancellable={false}
        isWizard={false}
      />
    </Modal>
  );
};
